import $http from '@/http';

const state = () => {
  return {
    brandList: [],
    currentBrandInfo: {}
  };
};

const getters = {
  getBrandList: (state) => {
    return state.brandList;
  },
  getCurrentBrandInfo: (state) => {
    return state.currentBrandInfo || {};
  }
};

const mutations = {
  setBrandList(state, brandList) {
    state.brandList = brandList;
  },
  setCurrentBrandInfo(state, currentBrandInfo) {
    state.currentBrandInfo = currentBrandInfo;
  }
};

const actions = {
  brandSubscribe({ commit, dispatch }) {
    $http({
      url: '/api/brand/subscribeUrls',
      method: 'post'
    }).then((res) => {
      if (res.status !== 200 || res.data.code !== 0) {
        this.$alertMsg(res.data ? res.data.message : res.statusText);
        return false;
      }
      res.data.data.forEach((item) => {
        commit('subscribe', {
          key: 'brandSubscribeUrl-' + item.brandId,
          subscribeUrl: item.subscribeUrl,
          callback: (body) => {
            if (body.changeType === 'UPDATE_BRAND') {
              dispatch('updateBrandData', body.data);
            }
          }
        });
      });
    });
  },
  updateBrandData({ state, commit }, brandData) {
    const idx = state.brandList.findIndex((t) => t.id === brandData.id);
    if (idx > -1) {
      if (brandData.displayStatus === 'SHOW') {
        const newBrandList = [...state.brandList];
        newBrandList.splice(idx, 1);
        newBrandList.splice(idx, 0, brandData);

        commit('setBrandList', newBrandList);
        commit('setCurrentBrandInfo', newBrandList[idx]);
      } else if (brandData.displayStatus === 'DELETE') {
        const newBrandList = [...state.brandList];
        newBrandList.splice(idx, 1);

        commit('setBrandList', newBrandList);
        commit('setCurrentBrandInfo', newBrandList[0]);
      }
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/brand/index.js